import './AboutUsContainer.css'
import useWindowDimensions from '../../../../hooks/useWindowDimensions'
import { Badge } from '@mantine/core'

export default function AboutUsContainer() {

   return (
      <section className="manifesto section-wrapper">
         <div className="manifesto-inner">
            <Badge>Nuestro manifiesto</Badge>
            <h2 className="manifesto-quote">
               La veterinaria en Latinoamérica tiene condiciones específicas, desafíos específicos, y merece <em>soluciones
                  específicas.</em>
            </h2>
            <p className="manifesto-body">
               Estamos cansados de importar protocolos pensados para otras realidades. De <strong>tomar decisiones</strong> clínicas <strong>en soledad</strong>.
               De sentir que la formación termina cuando te dan el título. FORVET existe porque creemos que el mejor criterio
               clínico no se construye solo — <strong>se construye en comunidad.</strong>
            </p>
            {/* <Link to="/institucional" className="manifesto-cta">
               Leer el manifiesto completo
               <svg width="16" height="16" fill="none" stroke="currentColor" stroke-width="2" viewBox="0 0 24 24">
                  <path d="M5 12h14M12 5l7 7-7 7" />
               </svg>
            </Link> */}
         </div>

      </section>
   )
}
